
import Bubble from "../../../assets/outline/Bubble.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BubbleIcon({ className, dataTestid = "BubbleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Bubble data-testid={dataTestid} className={classes} {...rest} />
  );
}
